<div class="topline">
    <mat-form-field>
        <mat-label>State Filter</mat-label>
        <mat-select (selectionChange)="setStatusFilter($event)">
            <mat-option value="all">All</mat-option>
            <mat-option *ngFor="let value of filterValues" [value]="value"
                >{{ utilService.capitalize(value) }}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field>
        <mat-label>Campaign Filter</mat-label>
        <mat-select (selectionChange)="setCampaignFilter($event)">
            <mat-option value="all">All</mat-option>
            <mat-option *ngFor="let campaign of campaigns" [value]="campaign.id">{{ campaign.name }}</mat-option>
        </mat-select>
    </mat-form-field>
    <mat-form-field class="search">
        <mat-label>Search</mat-label>
        <input class="search" #search matInput placeholder="Search" [formControl]="searchForm" />
    </mat-form-field>
    <app-paginator [reload]="reload" [itemCount]="itemCount" (pageEvent)="pageEvent($event)"></app-paginator>
</div>
<table class="table" mat-table matSort [dataSource]="tableDataSource">
    <ng-container matColumnDef="campaignName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Campaign</th>
        <td class="cell" mat-cell *matCellDef="let item">{{ item.campaign.name }}</td>
    </ng-container>
    <ng-container matColumnDef="target">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Target</th>
        <td class="cell" mat-cell *matCellDef="let item">{{ item.target }}</td>
    </ng-container>
    <ng-container matColumnDef="channel">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Description</th>
        <td class="cell" mat-cell *matCellDef="let item">{{ item.channel }}</td>
    </ng-container>
    <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td class="cell" mat-cell *matCellDef="let item">{{ item.date | date : 'medium' }}</td>
    </ng-container>
    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
        <td class="cell" mat-cell *matCellDef="let item">{{ item.status }}</td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="columnNames"></tr>
    <tr class="listitem" mat-row *matRowDef="let rows; columns: columnNames"></tr>
</table>
